import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Smartphone, Globe, Brain, TrendingUp, ShoppingCart, Megaphone, ArrowRight, ExternalLink, Filter } from 'lucide-react';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CursorGlow from '../components/CursorGlow';
import ScrollProgress from '../components/ScrollProgress';

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const categories = [
    { id: 'all', name: 'Tümü', count: 12 },
    { id: 'mobile', name: 'Mobil Uygulama', count: 4 },
    { id: 'web', name: 'Web Projesi', count: 3 },
    { id: 'marketing', name: 'Dijital Pazarlama', count: 3 },
    { id: 'ecommerce', name: 'E-Ticaret', count: 2 }
  ];

  const projects = [
    {
      id: 1,
      title: 'FitLife Fitness Uygulaması',
      category: 'mobile',
      categoryLabel: 'Mobil Uygulama',
      image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&h=400&fit=crop',
      description: 'iOS ve Android için AI destekli fitness uygulaması. 500K+ indirme.',
      technologies: ['React Native', 'Node.js', 'TensorFlow'],
      results: ['500K+ İndirme', '4.9 Puan', '%68 Retention'],
      link: '/portfolyo/mobil-uygulama',
      color: 'from-purple-500 to-pink-500'
    },
    {
      id: 2,
      title: 'TechStore SEO Projesi',
      category: 'marketing',
      categoryLabel: 'SEO & Dijital Pazarlama',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop',
      description: 'E-ticaret sitesi için kapsamlı SEO çalışması. Organik trafik %340 arttı.',
      technologies: ['SEO', 'Google Ads', 'Analytics'],
      results: ['%340 Trafik Artışı', '850+ Anahtar Kelime', 'DA 58'],
      link: '/portfolyo/seo',
      color: 'from-green-500 to-emerald-500'
    },
    {
      id: 3,
      title: 'FreshBite Sosyal Medya',
      category: 'marketing',
      categoryLabel: 'Sosyal Medya',
      image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=600&h=400&fit=crop',
      description: 'Restoran zinciri için sosyal medya yönetimi. Etkileşim 3 kat arttı.',
      technologies: ['Instagram', 'TikTok', 'Meta Ads'],
      results: ['3x Etkileşim', '125K Takipçi', '2.5M Görüntüleme'],
      link: '/portfolyo/sosyal-medya',
      color: 'from-pink-500 to-purple-500'
    },
    {
      id: 4,
      title: 'FinTrack Dashboard',
      category: 'web',
      categoryLabel: 'Web Uygulaması',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop',
      description: 'Fintech için gerçek zamanlı finansal dashboard. 15K+ aktif kullanıcı.',
      technologies: ['React', 'Node.js', 'PostgreSQL'],
      results: ['15K Kullanıcı', '0.8s Yüklenme', '98 Lighthouse'],
      link: '/portfolyo/web',
      color: 'from-blue-500 to-indigo-500'
    },
    {
      id: 5,
      title: 'MediCare Sağlık Uygulaması',
      category: 'mobile',
      categoryLabel: 'Mobil Uygulama',
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=400&fit=crop',
      description: 'Hasta takip ve randevu sistemi. AI destekli semptom analizi.',
      technologies: ['Flutter', 'Firebase', 'ML Kit'],
      results: ['200K+ Kullanıcı', '4.7 Puan', 'AI Özellikler'],
      link: '/portfolyo/mobil-uygulama',
      color: 'from-cyan-500 to-blue-500'
    },
    {
      id: 6,
      title: 'ShopEase E-Ticaret',
      category: 'ecommerce',
      categoryLabel: 'E-Ticaret',
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop',
      description: 'Hazır giyim markası için e-ticaret platformu ve ERP entegrasyonu.',
      technologies: ['Next.js', 'Shopify', 'SAP'],
      results: ['%200 Satış Artışı', 'ERP Entegrasyonu', 'Mobil Uyumlu'],
      link: '/portfolyo/web',
      color: 'from-orange-500 to-red-500'
    },
    {
      id: 7,
      title: 'EduLearn Platform',
      category: 'web',
      categoryLabel: 'Web Platformu',
      image: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=600&h=400&fit=crop',
      description: 'Online eğitim platformu. Canlı dersler ve interaktif içerik.',
      technologies: ['React', 'WebRTC', 'MongoDB'],
      results: ['25K Öğrenci', '500+ Ders', '%98 Memnuniyet'],
      link: '/portfolyo/web',
      color: 'from-teal-500 to-green-500'
    },
    {
      id: 8,
      title: 'DeliverFast Lojistik',
      category: 'mobile',
      categoryLabel: 'Mobil Uygulama',
      image: 'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=600&h=400&fit=crop',
      description: 'Kurye takip ve teslimat yönetimi uygulaması. Gerçek zamanlı takip.',
      technologies: ['React Native', 'Google Maps', 'Socket.io'],
      results: ['50K Teslimat/Gün', 'Anlık Takip', 'Route Optimizasyonu'],
      link: '/portfolyo/mobil-uygulama',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      id: 9,
      title: 'LuxuryHome E-Ticaret',
      category: 'ecommerce',
      categoryLabel: 'E-Ticaret',
      image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=600&h=400&fit=crop',
      description: 'Mobilya markası için premium e-ticaret deneyimi ve AR özelliği.',
      technologies: ['Vue.js', 'Three.js', 'Stripe'],
      results: ['AR Görüntüleme', '%150 Dönüşüm', 'Premium UX'],
      link: '/portfolyo/web',
      color: 'from-amber-500 to-yellow-500'
    },
    {
      id: 10,
      title: 'FoodieApp Sipariş',
      category: 'mobile',
      categoryLabel: 'Mobil Uygulama',
      image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=600&h=400&fit=crop',
      description: 'Yemek sipariş ve restoran keşif uygulaması.',
      technologies: ['React Native', 'Firebase', 'Stripe'],
      results: ['300K Kullanıcı', '1M+ Sipariş', '4.6 Puan'],
      link: '/portfolyo/mobil-uygulama',
      color: 'from-red-500 to-pink-500'
    },
    {
      id: 11,
      title: 'TravelBuddy Google Ads',
      category: 'marketing',
      categoryLabel: 'Google Ads',
      image: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=600&h=400&fit=crop',
      description: 'Seyahat acentesi için Google Ads ve Meta Ads kampanyaları.',
      technologies: ['Google Ads', 'Meta Ads', 'Analytics'],
      results: ['%450 ROAS', '%65 CPA Düşüşü', '2x Rezervasyon'],
      link: '/portfolyo/seo',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      id: 12,
      title: 'CorpSite Kurumsal Web',
      category: 'web',
      categoryLabel: 'Kurumsal Website',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&h=400&fit=crop',
      description: 'Holding şirketi için kurumsal website ve yatırımcı portalı.',
      technologies: ['Next.js', 'Headless CMS', 'Vercel'],
      results: ['Çok Dilli', 'SEO Uyumlu', 'Yatırımcı Portalı'],
      link: '/portfolyo/web',
      color: 'from-slate-500 to-gray-600'
    }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  return (
    <div className="min-h-screen bg-slate-900">
      <CursorGlow />
      <ScrollProgress />
      <Header />

      {/* Hero Section */}
      <section className="relative pt-32 pb-16 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute w-[600px] h-[600px] bg-cyan-500/20 rounded-full blur-3xl top-0 right-1/4 animate-pulse"></div>
          <div className="absolute w-[500px] h-[500px] bg-teal-500/20 rounded-full blur-3xl bottom-0 left-1/4 animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-6">
              <Filter className="w-4 h-4 text-cyan-400" />
              <span className="text-cyan-400 text-sm font-medium">Portfolyo</span>
            </div>

            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Çalışmalarımız &
              <span className="bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent"> Projelerimiz</span>
            </h1>

            <p className="text-xl text-gray-400 mb-8 leading-relaxed">
              100+ başarıyla tamamlanan proje. Mobil uygulamadan e-ticarete, 
              SEO'dan sosyal medyaya kadar geniş bir yelpaze.
            </p>
          </div>
        </div>
      </section>

      {/* Filters */}
      <section className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveFilter(cat.id)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all ${
                  activeFilter === cat.id
                    ? 'bg-gradient-to-r from-cyan-500 to-teal-500 text-white'
                    : 'bg-slate-800/50 text-gray-400 hover:text-white hover:bg-slate-700/50'
                }`}
                data-testid={`filter-${cat.id}`}
              >
                {cat.name}
                <span className="ml-2 text-xs opacity-70">({cat.count})</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project) => (
              <Link
                key={project.id}
                to={project.link}
                className="group bg-slate-800/40 backdrop-blur-sm border border-slate-700/50 rounded-2xl overflow-hidden hover:border-cyan-500/50 transition-all hover:-translate-y-2"
                data-testid={`project-${project.id}`}
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t ${project.color} opacity-40`}></div>
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-slate-900/80 text-white text-xs font-medium rounded-full">
                      {project.categoryLabel}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-2 group-hover:text-cyan-400 transition-colors">
                    {project.title}
                  </h3>
                  <p className="text-gray-400 text-sm mb-4 line-clamp-2">
                    {project.description}
                  </p>

                  {/* Technologies */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {project.technologies.map((tech, idx) => (
                      <span 
                        key={idx}
                        className="px-2 py-1 bg-slate-700/50 text-gray-300 text-xs rounded"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>

                  {/* Results */}
                  <div className="flex flex-wrap gap-2 pt-4 border-t border-slate-700/50">
                    {project.results.map((result, idx) => (
                      <span 
                        key={idx}
                        className="text-cyan-400 text-xs font-medium"
                      >
                        {result}{idx < project.results.length - 1 && ' • '}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-slate-950">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Projenizi
            <span className="bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent"> Hayata Geçirelim</span>
          </h2>
          <p className="text-gray-400 text-lg mb-8">
            Fikrinizi gerçeğe dönüştürmek için buradayız. Ücretsiz görüşme için hemen iletişime geçin.
          </p>
          <Link to="/iletisim">
            <Button className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white px-8 py-6 text-lg">
              Proje Görüşmesi Talep Et
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Portfolio;
